// scss
import './scss/styles.scss'

// js
import Vue from 'vue'
import App from './App.vue'
import store from './store'

Vue.config.productionTip = false

// Initialize Vue event bus for socket notifications (compatible with main app)
if (typeof window !== 'undefined' && (typeof window.vueEventBus === 'undefined' || window.vueEventBus === null)) {
  window.vueEventBus = new Vue()
}

new Vue({
  store,
  render: h => h(App)
}).$mount('.app')
